var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H8C4.83 2.25 2.25 4.83 2.25 8V16C2.25 19.17 4.83 21.75 8 21.75H16C19.17 21.75 21.75 19.17 21.75 16V8C21.75 4.83 19.17 2.25 16 2.25ZM20.25 16C20.25 18.34 18.34 20.25 16 20.25H8C5.66 20.25 3.75 18.34 3.75 16V8C3.75 5.66 5.66 3.75 8 3.75H16C18.34 3.75 20.25 5.66 20.25 8V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C14.07 12.75 15.75 11.07 15.75 9C15.75 6.93 14.07 5.25 12 5.25C9.93 5.25 8.25 6.93 8.25 9C8.25 11.07 9.93 12.75 12 12.75ZM12 6.75C13.24 6.75 14.25 7.76 14.25 9C14.25 10.24 13.24 11.25 12 11.25C10.76 11.25 9.75 10.24 9.75 9C9.75 7.76 10.76 6.75 12 6.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.25H10C7.93 14.25 6.25 15.93 6.25 18C6.25 18.41 6.59 18.75 7 18.75C7.41 18.75 7.75 18.41 7.75 18C7.75 16.76 8.76 15.75 10 15.75H14C15.24 15.75 16.25 16.76 16.25 18C16.25 18.41 16.59 18.75 17 18.75C17.41 18.75 17.75 18.41 17.75 18C17.75 15.93 16.07 14.25 14 14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkClient);
export default __webpack_public_path__ + "static/media/link-client.cd7f72470162d6198bfb8d28c0bbe15c.svg";
export { ForwardRef as ReactComponent };